export function initTeamSliderBig() {
    $('#team__slider').slick({
        initialSlide: 0,
        fade: true,
        arrows: true,
        infinite: true,
        speed: 800,
        cssEase: 'linear',
        nextArrow: '.team .btn-arrow--next',
        prevArrow: '.team .btn-arrow--prev',
        responsive: [
            {
                breakpoint: 905,
                settings: {
                    speed: 500,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    fade: false,
                    speed: 300,
                }
            },
        ]
    });

    $('#team__slider').on('init reInit afterChange', function(event, slick, currentSlide){
        let i = (currentSlide ? currentSlide : 0) + 1;
        let total = slick.slideCount;

        $('#team .list__pagination span:first-child').text(String(i).padStart(2, '0'));
        $('#team .list__pagination span:last-child').text(String(total).padStart(2, '0'));
    });
}

export function initTeamSliderSmall() {
    $('#team__slider--clone').slick({
        initialSlide: 1,
        fade: true,
        arrows: false,
        infinite: true,
        speed: 800,
        cssEase: 'linear',
    });

    $('#team__slider').on('swipe', function(event, slick, direction){
        changeSlide(direction, $('#team__slider--clone'));
    });

    $('#team__slider--clone').on('swipe', function(event, slick, direction){
        changeSlide(direction, $('#team__slider'));
    });

    document.querySelector('.team .btn-arrow--next').addEventListener('click', function () {
        changeSlide('left', $('#team__slider--clone'));
    })

    document.querySelector('.team .btn-arrow--prev').addEventListener('click', function () {
        changeSlide('right', $('#team__slider--clone'));
    })

    function changeSlide(dir, slider) {
        if (dir === 'right') {
            slider.slick('slickPrev');
        } else {
            slider.slick('slickNext');
        }
    }
}
